import axios from "axios";

const backendApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api",
  withCredentials: true,
});

export default backendApi;
